import { pushData, basketCustomParams, orderConfCustomParams } from '@ynap/live-chat'

const lpTagCustomParamsMap: { [key: string]: (data: any, config: any) => any } = {
    '': () => false,
    cart: basketCustomParams,
    transaction: orderConfCustomParams,
}

type PushToLiveChatType = (data: { event: string } & { [key: string]: any }, lpTag?: { customParam?: string; customSection?: string }) => void

/**
 * {customDataFormatFn} is the function which formats the data from analytics
 * which function to call is determined by which {customParam} is sent, or the presence of {data.cart}
 * should only call push if config is active and (event is 'trackPage' OR customParam is sent)
 * @param data analytics data
 * @param lpTag so components can cammunicate with this script through react-track dispatch system
 */
const pushDataToLiveChat: PushToLiveChatType = (data, lpTag) => {
    const shouldPushToLiveChat = data.event == 'trackPage' || lpTag?.customParam
    const customDataFormatFn = lpTagCustomParamsMap[lpTag?.customParam || (data.cart && 'cart') || '']
    const formattedData = customDataFormatFn(data, lpTag?.customSection)

    if (shouldPushToLiveChat && formattedData) {
        const additionalSections: string[] = []
        const country: string | undefined = data.page?.pageInfo?.geoRegion?.toUpperCase()
        const liveChatCountry = country === 'US' ? country : undefined
        liveChatCountry && additionalSections.push(liveChatCountry)
        pushData({ ...formattedData, additionalSections })
    }
}

export default pushDataToLiveChat
